<div [ngClass]="{'scout-pt-disabled-wrapper': !isEditing&&scoutPoint.disabled}" class="container-fluid">
<form #scoutPointForm="ngForm" class="pb-2 scout-pt-form"
[ngClass]="scoutPoint.disabled&&'scout-pt-disabled-form'">

    <div *ngIf="scoutPoint">
        <div class="m-0 p-0" [ngSwitch]="scoutPoint.type">
            <div *ngSwitchCase="'EX'" class="container-fluid" [ngClass]="locked?'disabled':''">
                <ng-container *ngTemplateOutlet="notHighAccuracyPoint"></ng-container>
            </div>
            <div *ngSwitchCase="'VIA'" class="container-fluid" [ngClass]="locked?'disabled':''">
                <ng-container *ngTemplateOutlet="notHighAccuracyPoint"></ng-container>
            </div>
            <div *ngSwitchCase="'HA'" class="container-fluid p-0" [ngClass]="locked?'disabled':''">
                <div *ngIf="showTitlebar&&scoutPoint.pointId!=NewPointId; else newHaPointTitle" class="col-12 font-weight-bold text-nowrap text-center" role="button" (click)="selected.emit(scoutPoint)"
                [ngClass]="scoutPoint.disabled&&'scout-pt-header-disabled'">
                    High Accuracy Point
                </div>
                <ng-template #newHaPointTitle>
                    <div class="px-3">
                        <ng-container *ngTemplateOutlet="pointTitleBar"></ng-container>
                    </div>
                </ng-template>
                <div>
                    <div *ngIf="scoutPoint.parentId">
                        <ng-container [ngTemplateOutlet]="fromPointSection" [ngTemplateOutletContext]="{labelClass:'col-4',valueClass:'col-5'}"></ng-container>
                        <ng-container [ngTemplateOutlet]="selectPointTypeSection" [ngTemplateOutletContext]="{labelClass:'col-4',valueClass:'col-5'}"></ng-container>
                    </div>
                    <div class="row" *ngIf="isEditing||scoutPoint.pointId!=NewPointId">
                        <div class="col-4 scout-pt-label-cell" role="button" (click)="onShowPoint(scoutPoint.pointId)">
                            Point ID
                        </div>
                        <div *ngIf="isEditing" class="col-5 text-left px-0" [ngClass]="isLoadingBuildingPoints?'disabled':''">
                            <div *ngIf="isLoadingBuildingPoints" class="small busy-overlay">
                                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
                            </div>
                            <select #buildingPointSelect name="buildingPointSelect" [(ngModel)]="scoutPoint.pointId"
                                (change)="onPointIdChanged()" >
                                <option *ngFor="let buildingPoint of haBuildingPoints" [ngValue]="buildingPoint._id"
                                        [selected]="buildingPoint._id==scoutPoint.pointId">
                                    <ng-container *ngIf="buildingPoint._id!=NewPointId; else newPointOption">
                                        {{buildingPoint._id}} ({{buildingPoint.floorName}})
                                    </ng-container>
                                    <ng-template #newPointOption>
                                       - New -
                                    </ng-template>
                                </option>
                            </select>
                        </div>
                        <div *ngIf="!isEditing" class="col-5 text-right scout-pt-value-cell even-value-cell"
                                role="button" (click)="onValueClicked('pointId')">
                            {{scoutPoint.pointId}}
                        </div>
                    </div>
                    <div class="row" *ngIf="scoutPoint.pointId==NewPointId">
                        <div class="col-4 scout-pt-label-cell">
                            New ID
                        </div>
                        <div *ngIf="!isEditing" class="col-5 text-right text-nowrap scout-pt-value-cell even-value-cell"
                            style="border-top: none;" role="button" (click)="onValueClicked('exPointId')">
                            {{scoutPoint.exPointId}}
                        </div>
                        <div *ngIf="isEditing" class="col-5 scout-pt-value-input-cell">
                            <input name="exPointId" type='text' class="w-100" size="12"
                                [(ngModel)]="scoutPoint.exPointId" #exPointId="ngModel"
                                [ngClass]="{ 'invalid-input': exPointId.invalid && (exPointId.dirty || exPointId.touched)}" >
                        </div>
                    </div>
                    <ng-container *ngIf="!isEditing||scoutPoint.pointId!=NewPointId; else editingNewHaPoint">
                    <div class="row">
                        <div class="col-4 scout-pt-label-cell">Latitude</div>
                        <div class="col-5 text-right scout-pt-value-cell" style="border-top: none;"
                            role="button" (click)="onValueClicked('latitude')">
                            {{scoutPoint.latitude|number:'0.2-6'}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 scout-pt-label-cell">Longitude</div>
                        <div class="col-5 text-right scout-pt-value-cell even-value-cell" style="border-top: none;"
                            role="button" (click)="onValueClicked('longitude')">
                            {{scoutPoint.longitude|number:'0.2-6'}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 scout-pt-label-cell">Height</div>
                        <div class="col-5 text-right scout-pt-value-cell" style="border-top: none;"
                            role="button" (click)="onValueClicked('altitudeEllipsoidMeters')">
                            {{scoutPoint.altitudeEllipsoidMeters|number:'0.2-6'}}</div>
                        <div class="col-3 pl-1 pr-0 justify-content-start scout-pt-label-cell">meters</div>
                    </div>
                    </ng-container>
                    <ng-template #editingNewHaPoint>
                        <div class="row">
                            <div class="col-4 scout-pt-label-cell">Latitude</div>
                            <div class="col-5 scout-pt-value-input-cell">
                                <input name="latitude" type='text' class="w-100" placeholder="decimal"
                                    [(ngModel)]="scoutPoint.latitude" #latitude="ngModel" required number [min]="-90" [max]="90"
                                    [ngClass]="{ 'invalid-input': latitude.invalid && (latitude.dirty || latitude.touched)}" >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 scout-pt-label-cell">Longitude</div>
                            <div class="col-5 scout-pt-value-input-cell">
                                <input name="longitude" type='text' class="w-100" placeholder="decimal"
                                    [(ngModel)]="scoutPoint.longitude" #longitude="ngModel" required number [min]="-180" [max]="180"
                                    [ngClass]="{ 'invalid-input': longitude.invalid && (longitude.dirty || longitude.touched)}" >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 scout-pt-label-cell">Height</div>
                            <div class="col-5 scout-pt-value-input-cell">
                                <input name="altitudeEllipsoidMeters" type='text' class="w-100" placeholder="meters"
                                    [(ngModel)]="scoutPoint.altitudeEllipsoidMeters" #altitudeEllipsoidMeters="ngModel" required number
                                    [ngClass]="{ 'invalid-input': altitudeEllipsoidMeters.invalid && (altitudeEllipsoidMeters.dirty || altitudeEllipsoidMeters.touched)}" >
                            </div>
                            <div class="col-3 pl-1 pr-0 justify-content-start scout-pt-label-cell">meters</div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="row pt-sm-1" *ngIf="scoutPoint?.type!='HA'&&showErrorCalcFields">
                <div class="col-4 scout-pt-label-cell">
                    <i class="far" (click)="onDerivedFromExternalWallClick()"
                        [ngClass]="scoutPoint.horizontalError?.derivedFromExternalWall?'fa-check-square': 'fa-square'">
                    </i>
                </div>
                <div class="col-8 pl-0 justify-content-start text-left scout-pt-label-cell" role="button" (click)="onValueClicked('derivedFromExternalWall')">
                    Bearing Derived from External Wall
                </div>
                <div class="col-4 scout-pt-label-cell">
                    <i class="far" (click)="onUnlevelFloorClick()"
                        [ngClass]="scoutPoint.verticalError?.unlevelFloor?'fa-check-square': 'fa-square'">
                    </i>
                </div>
                <div class="col-8 pl-0 justify-content-start text-left scout-pt-label-cell" role="button" (click)="onValueClicked('unlevelFloor')">
                    Unlevel Floor
                </div>
            </div>
            <div *ngSwitchDefault>
                Unknown Point Type: {{scoutPoint.type}}
            </div>
        </div>

    </div>

    <ng-template #notHighAccuracyPoint>
        <ng-container *ngTemplateOutlet="pointTitleBar"></ng-container>
        <ng-container [ngTemplateOutlet]="fromPointSection" [ngTemplateOutletContext]="{labelClass:'col-5',valueClass:'col-4'}"></ng-container>
        <!--<div draggable="true" ondragstart="event.preventDefault(); event.stopPropagation();" style="cursor: default !important;">-->
        <div>
            <ng-container [ngTemplateOutlet]="selectPointTypeSection" [ngTemplateOutletContext]="{labelClass:'col-5',valueClass:'col-4'}"></ng-container>
            <div class="row">
                <div class="col-5 scout-pt-label-cell text-nowrap">Horiz. Distance</div>
                <div *ngIf="!isEditing" class="col-4 text-right scout-pt-value-cell even-value-cell"
                    style="border-top: none;" role="button" (click)="onValueClicked('horizontalDistance')">
                    {{scoutPoint.horizontalDistance|number:'1.0-4'}}
                </div>
                <div *ngIf="isEditing" class="col-4 scout-pt-value-input-cell">
                    <input name="horizontalDistance" type='number' class="w-100" size="4" placeholder="meters..."
                        [(ngModel)]="scoutPoint.horizontalDistance" #horizontalDistance="ngModel" required number [min]="0"
                        [ngClass]="{ 'invalid-input': horizontalDistance.invalid && (horizontalDistance.dirty || horizontalDistance.touched)}" >
                </div>
                <div class="col-3 pl-1 pr-0 justify-content-start scout-pt-label-cell">meters</div>
            </div>
            <div class="row">
                <div class="col-5 scout-pt-label-cell">Bearing</div>
                <div *ngIf="!isEditing" class="col-4 text-right scout-pt-value-cell" style="border-top: none;"
                    role="button" (click)="onValueClicked('bearing')">
                    {{scoutPoint.bearing|number:'1.0-4'}}
                </div>
                <div *ngIf="isEditing" class="col-4 scout-pt-value-input-cell">
                    <div class="d-flex flex-row p-0 m-0">
                        <input name="bearing" type='number' class="w-100" size="4" placeholder="degrees..."
                            [(ngModel)]="scoutPoint.bearing" #bearing="ngModel" required number [min]="0" [lt]="360"
                            [ngClass]="{ 'invalid-input': bearing.invalid && (bearing.dirty || bearing.touched)}" >
                        <div *ngIf="bearingDefaultAngles?.length" class="btn-group p-0 m-0" dropdown>
                            <button title="Azimuth Angles" class="btn btn-secondary dropdown-toggle" style="padding: 0 2px;" dropdownToggle>
                            </button>
                            <div *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu">
                                <div class="d-flex flex-wrap justify-content-around">
                                <div *ngFor="let angle of bearingDefaultAngles; index as index" [ngClass]="{'mb-sm-1': index%2&&index!=1}">
                                    <button class="btn btn-secondary" (click)="onBearingSelected(angle)" style="width:4em;padding: 0;margin:1px;">
                                        {{angle}}&deg;
                                        &nbsp;<i class="fa fa-long-arrow-alt-up" [ngStyle]="{transform: 'rotate('+angle+'deg)'}"></i>
                                    </button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3 pl-1 pr-0 justify-content-start scout-pt-label-cell">degrees</div>
            </div>
            <div class="row">
                <div class="col-5 scout-pt-label-cell text-nowrap">Height Offset</div>
                <div *ngIf="!isEditing" class="col-4 text-right scout-pt-value-cell even-value-cell"
                    style="border-top: none;"  role="button"  (click)="onValueClicked('heightOffset')">
                    {{scoutPoint.heightOffset}}
                </div>
                <div *ngIf="isEditing" class="col-4 scout-pt-value-input-cell">
                    <input name="heightOffset" type='number' class="w-100" size="4" placeholder="meters..."
                        [(ngModel)]="scoutPoint.heightOffset" #heightOffset="ngModel" number
                        [ngClass]="{ 'invalid-input': heightOffset.invalid && (heightOffset.dirty || heightOffset.touched)}" >
                </div>
                <div class="col-3 pl-1 pr-0 justify-content-start scout-pt-label-cell">meters</div>
            </div>
        </div>
        <div class="pt-2 row" *ngIf="scoutPoint.type=='EX'">
            <div class="col-3 scout-pt-label-cell text-nowrap" title="The point ID to use when scout path is approved and point record is created">
                Point ID
            </div>
            <div *ngIf="!isEditing" class="col-9 text-right scout-pt-value-cell" style="border-top: none;"
                role="button" (click)="onValueClicked('exPointId')">
                {{scoutPoint.exPointId}}
            </div>
            <div *ngIf="isEditing" class="col-9 scout-pt-value-input-cell">
                <div class="d-flex flex-row p-0 m-0">
                <input name="exPointId" type='text' class="w-100"
                    [title]="exPointId.errors?.['pattern'] ? 'Point ID cannot include whitespace' : ''"
                    [(ngModel)]="scoutPoint.exPointId" #exPointId="ngModel" [pattern]="'^[^ ^\t]*$'"
                    [ngClass]="{ 'invalid-input': exPointId.invalid && (exPointId.dirty || exPointId.touched)}" >
                <div class="btn-group p-0 m-0" dropdown>
                    <button title="EX Name Suggestions" class="btn btn-secondary dropdown-toggle"
                            (click)="rebuildPointNameSuggestions()" style="padding: 0 2px;" dropdownToggle>
                    </button>
                    <ul *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu">
                        <li *ngFor="let nameSuggestion of exNameSuggestions;" role="button" (click)="scoutPoint.exPointId=nameSuggestion">
                            {{nameSuggestion}}
                        </li>
                    </ul>
                </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #pointTitleBar>
        <div *ngIf="showTitlebar" class="scout-point-title-bar row" role="button" (click)="selected.emit(scoutPoint)"
        [ngClass]="scoutPoint.disabled&&'scout-pt-header-disabled'">
            <div class="col-10 m-0 d-flex flex-column text-nowrap align-items-center"
                [ngStyle]="{'background-color': scoutPoint.color}">
                Measurement {{scoutPoint.name}}
            </div>
            <div class="col-2 font-weight-bold justify-content-center scout-pt-value-cell">
                {{ scoutPoint.type }}
            </div>
        </div>
    </ng-template>

    <ng-template #fromPointSection let-labelClass="labelClass" let-valueClass="valueClass">
        <div class="row">
            <div class="{{labelClass}} scout-pt-label-cell">
                From
            </div>
            <div *ngIf="isEditing" class="{{valueClass}} text-left px-0">
                <select #fromSegmentSelect name="fromSegmentSelect" class="w-100"
                    (change)="onFromChanged()" [(ngModel)]="scoutPoint.parentId" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let pt of scoutFromOptions"
                        style="text-shadow: 1px 1px gray" [ngValue]="pt.id" class="font-weight-bold" [ngStyle]="{'color': pt.color}">
                        {{pt.name}}
                    </option>
                </select>
            </div>
            <div *ngIf="!isEditing && scoutPoint.parentName" class="{{valueClass}} text-nowrap font-weight-bold scout-pt-value-cell"
                [ngStyle]="{'color': scoutPoint.parentColor}" role="button" (click)="onValueClicked('parentName')">
                {{scoutPoint.parentName}}
            </div>
        </div>
    </ng-template>

    <ng-template #selectPointTypeSection let-labelClass="labelClass" let-valueClass="valueClass">
        <div *ngIf="isEditing" class="row">
            <div class="{{labelClass}} scout-pt-label-cell">Type</div>
            <div class="{{valueClass}} text-left px-0">
                <select #pointTypeSelect name="pointTypeSelect"  class="w-100" (ngModelChange)="onTypeChanged($event)" [ngModel]="scoutPoint.type">
                    <option *ngFor="let pointType of ['EX','VIA','HA']" [ngValue]="pointType">{{pointType}}</option>
                </select>
            </div>
        </div>
    </ng-template>

</form>
</div>

